import { AfterViewInit, Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject ,  Subscription } from "rxjs";
import { NSFormFields } from "../../../../types";
import { FieldStateService } from "../../field-state.service";

@Injectable()
export class CheckboxGroupStateService extends FieldStateService implements AfterViewInit, OnDestroy {
    public stateObservable$: BehaviorSubject<any>;
    public stateSubscriber$: Subscription;
    public fieldOptions: NSFormFields.IOptionsState[];
    public selectedValue: string[] = [];

    constructor() {
        super();
    }

    public ngAfterViewInit() {
        this.stateSubscriber$ = this.stateObservable$.subscribe((state) => {
            this.selectedValue = state.selectedValue || this.selectedValue;
            if (state.options) {
                this.fieldOptions = state.options.map((option) => {
                    option.state = this.selectedValue.some((x) => x === option.value);
                });
            }
        });
    }

    public ngOnDestroy() {
        if (this.stateSubscriber$) { this.stateSubscriber$.unsubscribe(); }
    }

    public transformAndDispatchFieldUpdate(payload) {
        if (payload != null) {
            if (this.selectedValue.some((x) => x === payload)) {
                this.selectedValue = this.selectedValue.filter((x) => x !== payload);
            } else {
                this.selectedValue = [...this.selectedValue, payload];
            }
            const toggledKeys = this.selectedValue.sort();
            this.dispatchFieldUpdate(toggledKeys);
        }
    }

    public dispatchFieldUpdate(toggledKeys) {
        if (toggledKeys != null) {
            const newState = super.newState({ selectedValue: toggledKeys, value: toggledKeys });
            this.selectedValue = newState.selectedValue;
            this.stateObservable$.next(newState);
        }
    }

    public dispatchFieldLoad(payload): void {
        this.dispatchFieldUpdate(payload);
    }

    public dispatchListLoad(payload, ...args): void {
        const fieldOptionsLabelPath = args[0];
        const fieldOptionsIdPath = args[1];
        const options = payload.map((option) => {
            return {
                label: option[fieldOptionsLabelPath] || option.label,
                value: option[fieldOptionsIdPath] || option.value,
                state: undefined,
            };
        });
        this.stateObservable$.next(super.newState({ options }));
    }

    public dispatchStateReset(initialState): void {
        const options = this.fieldOptions;
        this.stateObservable$.next(super.newState({ options }));
    }
}
